module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_5_.8730f964.png";